import * as type from "../../types/API/dashboardType";
import { IAction } from "../userMetadataReducer";

const initialState = {
    itemsCount: 0,
    storesCount: 0,
    usersCount: 0,
    companiesCount: 0,
    documentsCount: 0,
    itemsSalesSummary: [],
    invoiceSummary: [],
    predictionValue: 0,
    predictSales: {},
    itemsSalesSummaryWithPrediction: {},
    dashboardData: {},
    salesDashboardDetails: []
};

export const getItemsCount = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_ITEMS_COUNT:
            return {
                ...state,
            };
        case type.GET_ITEMS_COUNT_SUCCESS:
            return {
                ...state,
                itemsCount: action.payload.responseData.totalItems
            };
        case type.GET_ITEMS_COUNT_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getStoresCount = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_STORES_COUNT:
            return {
                ...state,
            };
        case type.GET_STORES_COUNT_SUCCESS:
            return {
                ...state,
                storesCount: action.payload.responseData.totalStores
            };
        case type.GET_STORES_COUNT_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getUsersCount = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_USERS_COUNT:
            return {
                ...state,
            };
        case type.GET_USERS_COUNT_SUCCESS:
            return {
                ...state,
                usersCount: action.payload.responseData.totalUsers
            };
        case type.GET_USERS_COUNT_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getDocumentsCount = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_DOCUMENTS_COUNT:
            return {
                ...state,
            };
        case type.GET_DOCUMENTS_COUNT_SUCCESS:
            return {
                ...state,
                documentsCount: action.payload.responseData.totalDocuments
            };
        case type.GET_DOCUMENTS_COUNT_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getCompaniesCount = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_COMPANIES_COUNT:
            return {
                ...state,
            };
        case type.GET_COMPANIES_COUNT_SUCCESS:
            return {
                ...state,
                companiesCount: action.payload.responseData.data.company
            };
        case type.GET_COMPANIES_COUNT_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getItemsSalesSummary = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_ITEMS_SALES_SUMMARY:
            return {
                ...state,
            };
        case type.GET_ITEMS_SALES_SUMMARY_SUCCESS:
            return {
                ...state,
                itemsSalesSummary: action.payload.responseData
            };
        case type.GET_ITEMS_SALES_SUMMARY_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getInvoiceSummary = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_INVOICE_SUMMARY:
            return {
                ...state,
            };
        case type.GET_INVOICE_SUMMARY_SUCCESS:
            return {
                ...state,
                invoiceSummary: action.payload.responseData
            };
        case type.GET_INVOICE_SUMMARY_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getPredictionValue = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.PREDICT_NEXT_VALUE:
            return {
                ...state,
            };
        case type.PREDICT_NEXT_VALUE_SUCCESS:
            return {
                ...state,
                predictionValue: action.payload.responseData
            };
        case type.PREDICT_NEXT_VALUE_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getItemsSalesSummaryWithPrediction = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION:
            return {
                ...state,
            };
        case type.GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_SUCCESS:
            return {
                ...state,
                itemsSalesSummaryWithPrediction: action.payload.responseData
            };
        case type.GET_ITEMS_SALES_SUMMARY_WITH_PREDICTION_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getSalesPrediction = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.PREDICT_SALES:
            return {
                ...state,
            };
        case type.PREDICT_SALES_SUCCESS:
            return {
                ...state,
                predictSales: action.payload.responseData
            };
        case type.PREDICT_SALES_FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export const getDashboardData = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_DASHBOARD_DATA:
            return {
                ...state,
                loading: true
            };
        case type.GET_DASHBOARD_DATA_SUCCESS:
            return {
                ...state,
                dashboardData: action.payload.responseData,
                loading: false
            };
        case type.GET_DASHBOARD_DATA_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};

export const getStoreWiseItems = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_STORE_WISE_ITEMS:
            return {
                ...state,
                loading: true
            };
        case type.GET_STORE_WISE_ITEMS_SUCCESS:
            return {
                ...state,
                storeWiseItems: action.payload.responseData,
                loading: false
            };
        case type.GET_STORE_WISE_ITEMS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }   
}

export const getCategoryWiseItems = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_CATEGORY_WISE_ITEMS:
            return {
                ...state,
                loading: true
            };
        case type.GET_CATEGORY_WISE_ITEMS_SUCCESS:
            return {
                ...state,
                categoryWiseItems: action.payload.responseData,
                loading: false
            };
        case type.GET_CATEGORY_WISE_ITEMS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export const fastMovingSlowMovingItems = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.FAST_MOVING_SLOW_MOVING_ITEMS:
            return {
                ...state,
                loading: true
            };
        case type.FAST_MOVING_SLOW_MOVING_ITEMS_SUCCESS:
            return {
                ...state,
                fastMovingSlowMovingItems: action.payload.responseData,
                loading: false
            };
        case type.FAST_MOVING_SLOW_MOVING_ITEMS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export const stockLevelAnalysis = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.STOCK_LEVEL_ANALYSIS:
            return {
                ...state,
                loading: true
            };
        case type.STOCK_LEVEL_ANALYSIS_SUCCESS:
            return {
                ...state,
                stockLevelAnalysis: action.payload.responseData,
                loading: false
            };
        case type.STOCK_LEVEL_ANALYSIS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export const stockAgeing = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.STOCK_AGEING:
            return {
                ...state,
                loading: true
            };
        case type.STOCK_AGEING_SUCCESS:
            return {
                ...state,
                stockAgeing: action.payload.responseData,
                loading: false
            };
        case type.STOCK_AGEING_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export const onTimeDelayProduction = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.ON_TIME_DELAY_PRODUCTION: 
            return {
                ...state,
                loading: true
            };
        case type.ON_TIME_DELAY_PRODUCTION_SUCCESS:
            return {
                ...state,
                onTimeDelayProduction: action.payload.responseData,
                loading: false
            };
        case type.ON_TIME_DELAY_PRODUCTION_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export const workOrderStatus = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.WORK_ORDER_STATUS: 
            return {    
                ...state,
                loading: true
            };
        case type.WORK_ORDER_STATUS_SUCCESS:
            return {
                ...state,
                workOrderStatus: action.payload.responseData,
                loading: false
            };
        case type.WORK_ORDER_STATUS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}

export const getSalesDashboardDetails = (state = initialState, action: IAction) => {
    switch (action.type) {
        case type.GET_SALES_DASHBOARD_DETAILS:
            return {
                ...state,
                loading: true
            };
        case type.GET_SALES_DASHBOARD_DETAILS_SUCCESS:
            return {
                ...state,
                salesDashboardDetails: action.payload.responseData.data,
                loading: false
            };
        case type.GET_SALES_DASHBOARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}